import "./Com.css";
function AzkarHome() {
  return (
    <>
      <div class="hero-section">
        <div class="container">
          <h1>مرحبًا بك في حصن المسلم</h1>
          <p>أفضل مكان لقراءة وتعلم الأذكار</p>
          <a href="azkar-page.html" class="btn btn-primary">
            ابدأ الآن
          </a>
        </div>
      </div>
    </>
  );
}
export default AzkarHome;
